export default __webpack_public_path__ + "static/media/third.56a0062f.svg";